
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/batch/[slug]/[batchUID]",
      function () {
        return require("private-next-pages/store/batch/[slug]/[batchUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/batch/[slug]/[batchUID]"])
      });
    }
  